export default __webpack_public_path__ + "static/media/HistoricSolicitation.55643c67.svg";